import React from "react";
import styles from "./styles.module.scss";

function rowNumberFromFirstSegment(segment) {
  const s = segment.trim();
  if (/^\d+$/.test(s)) return s;
  const rowM = /^row\s*(\d+)$/i.exec(s);
  if (rowM) return rowM[1];
  const lineM = /^line\s*(\d+)$/i.exec(s);
  return lineM ? lineM[1] : null;
}

function rowNumberFromText(text) {
  if (!text || typeof text !== "string") return null;
  const m =
    /\brow\s*[:\s#]*(\d+)\b/i.exec(text) ||
    /\bline\s*[:\s#]*(\d+)\b/i.exec(text) ||
    /\bsheet\s*row\s*(\d+)\b/i.exec(text);
  return m ? m[1] : null;
}

/** Splits taskDetails for body; leading "N, …" only when N is row-like (Rate Card legacy keeps rest). */
function parseTaskDetails(taskDetails) {
  if (taskDetails == null || String(taskDetails).trim() === "") {
    return { rowLabel: null, body: "" };
  }
  const td = String(taskDetails).trim();

  const prefixRow = /^(?:row|line)\s*[:\s#]*(\d+)\s*[-–—:]\s*/i.exec(td);
  if (prefixRow) {
    return {
      rowLabel: `Row ${prefixRow[1]}`,
      body: td.slice(prefixRow[0].length).trim(),
    };
  }

  if (!td.includes(",")) {
    return { rowLabel: null, body: td };
  }

  const parts = td.split(",");
  const first = parts[0].trim();
  const rest = parts.slice(1).join(",").trim();
  const rowNum = rowNumberFromFirstSegment(first);

  if (rowNum != null) {
    return { rowLabel: `Row ${rowNum}`, body: rest };
  }

  return { rowLabel: null, body: rest };
}

function formatTaskSubtitle(statusMessage) {
  if (statusMessage == null || statusMessage === "") return "";
  return statusMessage.includes(">:")
    ? statusMessage.split(">:").slice(1).join(">:").trim()
    : statusMessage;
}

function resolveRowLabel(task, parsedRowLabel) {
  const id = task?.taskDetailsId;
  if (id != null && id !== "") return `Row ${id}`;
  if (parsedRowLabel) return parsedRowLabel;
  const blob = [task?.taskDetails, task?.statusMessage]
    .filter(Boolean)
    .join(" ");
  const n = rowNumberFromText(blob);
  return n ? `Row ${n}` : null;
}

export function UploadJobTasksList({ tasks }) {
  const raw = Array.isArray(tasks) ? tasks : [];
  const sorted = [...raw].sort(
    (a, b) => (Number(a?.taskDetailsId) || 0) - (Number(b?.taskDetailsId) || 0),
  );

  if (sorted.length === 0) {
    return (
      <p className={styles.empty} role="status">
        No job tasks found.
      </p>
    );
  }

  return (
    <ul className={styles.list}>
      {sorted.map((task, idx) => {
        const parsed = parseTaskDetails(task?.taskDetails);
        const rowLabel = resolveRowLabel(task, parsed.rowLabel);
        const body = parsed.body;
        const detail = formatTaskSubtitle(task?.statusMessage);

        return (
          <li className={styles.item} key={task?.id ?? idx}>
            {rowLabel ? (
              <div className={styles.rowBadge} aria-label="Spreadsheet row">
                {rowLabel}
              </div>
            ) : null}
            {body ? <p className={styles.title}>{body}</p> : null}
            {detail ? <p className={styles.detail}>{detail}</p> : null}
            {!body && !detail && !rowLabel ? (
              <p className={styles.empty}>No details for this task.</p>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
